// getLocalizationDefaultColumns
import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import RenderTextfieldHeader from '../../renderTextFieldHeader';
import FeedIcon from '@mui/icons-material/Feed';
import EditIcon from '@mui/icons-material/Edit';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { colorTypes, columnTypes, dateConfig, regionalFields, renderDateCell, renderTextCell } from './columnTypes';
import { renderOcplcSelectHeader } from 'pages/ocplcDashboard/ocplcHelpers';


const createTextColumn = (field, label, filters, handleChange, getColor = null) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderTextCell(params.row[field], getColor ? getColor(params.row.status) : undefined),
    renderHeader: () => (
        <RenderTextfieldHeader colData={columnTypes[field]} label={label} filters={filters} handleChange={handleChange} />
    ),
});

const createDateColumn = (field, label, filters, handleChange) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderDateCell(params.row[field]),
    renderHeader: () => (
        <RenderTextfieldHeader colData={columnTypes[field]} label={label} filters={filters} handleChange={handleChange} />
    ),
});

const createSelectColumn = (field, label, filters, handleChange, dropdownData) => ({
    headerName: label,
    field,
    width: 155,
    sortable: false,
    headerClassName: 'dashboard-data-grid-headers',
    renderCell: (params) => renderTextCell(params.row[field]),
    renderHeader: () => renderOcplcSelectHeader(columnTypes[field], filters, label, handleChange, dropdownData),
});


export const getLocalizationDefaultColumns = (
    filters,
    localizationDefaultData = [],
    handleChange,
    countryList,
    businessModels,
    regionDropdown,
    handleViewModel,
    region,
    disableAction,
    handleFeedDialog
) => {

    const isFieldNotEmpty = (field) =>
        localizationDefaultData.length > 0 && localizationDefaultData.every((row) => row[field]);


    const baseColumns = [
        createTextColumn('productFamily', 'Product Family', filters, handleChange,(status) => colorTypes[status] || 'grey'),
        createTextColumn('productDesc', 'Product Description', filters, handleChange),
        createTextColumn('feature', 'Feature', filters, handleChange),
        createTextColumn('featureValue', 'Feature Value', filters, handleChange),
        createTextColumn('locFeature', 'LOC Feature', filters, handleChange),
        createTextColumn('locFeatureValue', 'LOC Feature Value', filters, handleChange),
        createSelectColumn('region', 'Region', filters, handleChange, regionDropdown),
        createTextColumn('status', 'Status', filters, handleChange),
        createSelectColumn('country', 'Country ID', filters, handleChange, countryList),
        createTextColumn('countryDesc', 'Country Description', filters, handleChange),
        createTextColumn('comments', 'Comments', filters, handleChange),
        createTextColumn('whoChanged', 'Author', filters, handleChange),
    ].filter(Boolean);



   const actionColumn = {
    headerName: '',
    field: 'actions',
    width: 180,
    sortable: false,
    renderCell: (params) => {
        const actions = [
            {
                title: 'Audit Trail - Localization Default',
                icon: <FeedIcon />,
                onClick: () => handleFeedDialog(params.row, 'defaultLocAudit'),
            },
            {
                title: disableAction ? 'View' : 'Edit',
                icon: disableAction ? <VisibilityIcon /> : <EditIcon />,
                onClick: () => handleViewModel(params.row),
            }
        ];

        return (
            <Box onClick={(e) => e.stopPropagation()}>
                {actions.map((action, idx) => (
                    <Tooltip title={action.title} key={idx}>
                        <Button onClick={action.onClick} startIcon={action.icon} size="medium" />
                    </Tooltip>
                ))}
            </Box>
        );
    },
};


    return [...baseColumns, actionColumn];
};
